import Button from '../../Button'

import UploadButton from '../../../icons/upload-1.svg'

export const PAGE_EMPTY_STATES_AUTOMATE_PROCESS_ACTIONS = [
  {
    name: 'add-phase',
    text: 'Add new phase',
    onClick: () => window.alert('Clicked automate process add button. Nice!'),
  },
]

export const PAGE_EMPTY_STATES_BUILDINGS_ACTIONS = [
  {
    name: 'add-building',
    text: 'Add new building',
    onClick: () => window.alert('Clicked buildings add button. Nice!'),
  },
]

export const PAGE_EMPTY_STATES_BUILDINGS_GROUPS_ACTIONS = [
  {
    name: 'add-building-group',
    text: 'Add new group',
    onClick: () => window.alert('Clicked buildings groups edit button. Nice!'),
  },
]

export const PAGE_EMPTY_STATES_CHATS_ACTIONS = [
  {
    name: 'add-chat',
    text: 'Add new chat',
    onClick: () => window.alert('Clicked chats add button. Nice!'),
  },
]

export const PAGE_EMPTY_STATES_CONTACTS_ACTIONS = [
  {
    name: 'add-contact',
    text: 'Add new contanct',
    onClick: () => window.alert('Clicked contacts add button. Nice!'),
  },
]

export const PAGE_EMPTY_STATES_CUSTOMERS_ACTIONS = [
  {
    name: 'add-customer',
    text: 'Add new user',
    onClick: () => window.alert('Clicked customers add button. Nice!'),
  },
]

export const PAGE_EMPTY_STATES_DOCUMENT_SPLITTING_ACTIONS = [
  {
    Icon: UploadButton,
    name: 'document-splitting-upload',
    text: 'Upload',
    onClick: () =>
      window.alert('Clicked document splitting upload button. Nice!'),
  },
]

export const PAGE_EMPTY_STATES_DOCUMENTS_ACTIONS = [
  {
    Button: Button.White,
    Icon: UploadButton,
    name: 'upload-document',
    text: 'Upload',
    onClick: () => window.alert('Clicked documents upload button. Nice!'),
  },
  {
    name: 'add-folder',
    text: 'Add new folder',
    onClick: () => window.alert('Clicked documents add folder button. Nice!'),
  },
]

export const PAGE_EMPTY_STATES_EMAIL_INTEGRATIONS_ACTIONS = [
  {
    name: 'add-email-account',
    text: 'Add new email account',
    onClick: () => window.alert('Clicked email integrations add button. Nice!'),
  },
]

export const PAGE_EMPTY_STATES_EMAILS_ACTIONS = [
  {
    Icon: null,
    name: 'connect-email',
    text: 'Connect e-mail',
    onClick: () => window.alert('Clicked emails connect button. Nice!'),
  },
]

export const PAGE_EMPTY_STATES_EXTERNAL_CONTACTS_ACTIONS = [
  {
    name: 'add-new-contact',
    text: 'Add new contact',
    onClick: () => window.alert('Clicked external contacts add button. Nice!'),
  },
]

export const PAGE_EMPTY_STATES_FLATS_ACTIONS = [
  {
    name: 'add-flat',
    text: 'Add new flat',
    onClick: () => window.alert('Clicked flats add button. Nice!'),
  },
]

export const PAGE_EMPTY_STATES_INSURANCES_ACTIONS = [
  {
    name: 'add-insurance',
    text: 'Add new insurance',
    onClick: () => window.alert('Clicked insurances add button. Nice!'),
  },
]

export const PAGE_EMPTY_STATES_INVOICES_ACTIONS = [
  {
    name: 'add-invoice',
    text: 'Add new invoice',
    onClick: () => window.alert('Clicked invoices add button. Nice!'),
  },
]

export const PAGE_EMPTY_STATES_POSTS_ACTIONS = [
  {
    name: 'add-post',
    text: 'Add new post',
    onClick: () => window.alert('Clicked posts add button. Nice!'),
  },
]

export const PAGE_EMPTY_STATES_PROVIDERS_ACTIONS = [
  {
    name: 'add-provider',
    text: 'Add new provider',
    onClick: () => window.alert('Clicked providers add button. Nice!'),
  },
]

export const PAGE_EMPTY_STATES_RATING_ACTIONS = [
  {
    name: 'add-rating',
    text: 'Add new rating',
    onClick: () => window.alert('Clicked rating add button. Nice!'),
  },
]

export const PAGE_EMPTY_STATES_REQUESTS_ACTIONS = [
  {
    name: 'add-request',
    text: 'Add new request',
    onClick: () => window.alert('Clicked requests add button. Nice!'),
  },
]

export const PAGE_EMPTY_STATES_TASKS_ACTIONS = [
  {
    name: 'add-task',
    text: 'Add new task',
    onClick: () => window.alert('Clicked tasks add button. Nice!'),
  },
]

export const PAGE_EMPTY_STATES_USER_DATA_ACTIONS = [
  {
    Icon: UploadButton,
    name: 'upload-user-data',
    text: 'Upload',
    onClick: () => window.alert('Clicked user data upload button. Nice!'),
  },
  {
    name: 'user-data-example',
    text: 'Just example button',
    onClick: () => window.alert('Clicked user data example button. Nice!'),
  },
]

export const PAGE_EMPTY_STATES_USERS_ACTIONS = [
  {
    name: 'add-user',
    text: 'Add new user',
    onClick: () => window.alert('Clicked users add button. Nice!'),
  },
]
